
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"902","height":"841","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M722.101 0c-57.256 0-140.223 27.151-210.006 159.292l-21.378 40.455-24.66-38.566c-2.585-4.001-66.539-99.922-202.647-99.922-38.197 0-81.547 8.184-125.254 24.32C55.007 116.251 3.436 189.108.157 280.424-5.267 433.502 128.726 660.106 519.707 841c56.345-48.789 285.361-256.604 345.055-459.671 23.052-63.575 67.89-240.139 5.428-312.158C832.308 25.498 776.951 0 722.101 0z","fill":"#5B1CAD"}})])
          )
        }
      }
    